// @flow
import React from 'react';
import classNames from 'classnames';
// eslint-disable-next-line
import styles from "./styles.scss";

type Props = {
  imageUrl: string,
  caption?: string,
  className?: string,
  onClick: () => void,
};

export const ImageGalleryItemMobile = (props: Props) => {
  const { imageUrl, caption = '', className = '' } = props;
  const containerClass = classNames('image-gallery-item-mobile', className);

  return (
    <div className={containerClass} onClick={props.onClick}>
      <img src={imageUrl} alt={'Gallery'} />
      {caption && <p>{caption}</p>}
    </div>
  );
};
